import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SpeakerFilters from "./SpeakerFilters";
import { getIndustries } from "../../Api/Users/Lookups/GetIndustries";

function InviteModal({ onClose }) {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  toast.dismiss();
  const navigate = useNavigate();
  const { eventId, invitationId } = useParams();
  const [speakerId, setSpeakerId] = useState("");
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [speakers, setSpeakers] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [priceRanges, setPriceRanges] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const currentLang = i18n.language;
  const [searchClicked, setSearchClicked] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);

  const getLabel = (item) =>
    currentLang === "ar" ? item.arabicName : item.englishName;

  // دالعة عرض نتائج البحث
  const renderSearchSummary = () => {
    const parts = [];

    if (filters.keyword) parts.push(`${t("name")}: ${filters.keyword}`);

    if (filters.country) {
      const country = countries.find((c) => c.id === filters.country);
      if (country) parts.push(`${t("country")}: ${getLabel(country)}`);
    }

    if (filters.city) {
      const city = cities.find((c) => c.id === filters.city);
      if (city) parts.push(`${t("city")}: ${getLabel(city)}`);
    }

    if (filters.industry) {
      const industry = industries.find((i) => i.id === filters.industry);
      if (industry) parts.push(`${t("industry")}: ${getLabel(industry)}`);
    }

    if (filters.speciality) {
      const speciality = specialities.find((s) => s.id === filters.speciality);
      if (speciality) parts.push(`${t("speciality")}: ${getLabel(speciality)}`);
    }

    return parts.length > 0
      ? `${t("search_results_for")}: ${parts.join("، ")}`
      : null;
  };

  const [stats, setStats] = useState({
    total: 0,
    specialities: 0,
    countries: 0,
  });

  // للفلترة
  const [filters, setFilters] = useState({
    keyword: "",
    countryIds: [],
    cityIds: [],
    industryIds: [],
    specialityIds: [],
    gender: "",
    language: "",
    pricepriceRangeId: "",
  });

  const onFilterChange = (newFilters) => {
    console.log("New Filters: ", newFilters);
    handleFilterChange(newFilters);
  };

  const handleFilterChange = async (newFilters) => {
    console.log("Running filter change with:", newFilters);
    setFilters(newFilters);
    setCurrentPage(1);
    setHasSearched(true);

    const params = new URLSearchParams();

    if (newFilters.keyword) params.set("name", newFilters.keyword);
    newFilters.countryIds.forEach((id) => params.append("countryIds", id));
    newFilters.cityIds.forEach((id) => params.append("cityIds", id));
    newFilters.industryIds.forEach((id) => params.append("industryIds", id));
    newFilters.specialityIds.forEach((id) =>
      params.append("specialitiesId", id)
    );
    if (newFilters.gender) params.set("gender", newFilters.gender);
    if (newFilters.priceRangeId) params.set("price", newFilters.priceRangeId);

    params.set("page", 1);

    try {
      const response = await axiosInstance.get(
        `/api/v1/users/speakers?${params.toString()}`
      );

      setSpeakers(response.data.items || []);
    } catch (error) {
      console.error("Fetch speakers failed", error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFilters((prev) => ({ ...prev, [id]: value }));
  };

  const resetFilters = () => {
    const defaultFilters = {
      keyword: "",
      countryIds: [],
      cityIds: [],
      industryIds: [],
      specialityIds: [],
      gender: "",
      language: "",
      priceRangeId: "",
    };
    setFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  const handleSearch = () => {
    console.log("handleSearch clicked");
    setHasSearched(true);
    handleFilterChange(filters);
  };

  const fetchSpeakers = async (customFilters = filters) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/api/v1/users/speakers", {
        params: {
          Keyword: customFilters.keyword || "",
          CountryIds: customFilters.countryIds.length
            ? customFilters.countryIds
            : undefined,
          CityIds: customFilters.cityIds.length
            ? customFilters.cityIds
            : undefined,
          IndustryIds: customFilters.industryIds.length
            ? customFilters.industryIds
            : undefined,
          SpecialitiesId: customFilters.specialityIds.length
            ? customFilters.specialityIds
            : undefined,
          Gender: customFilters.gender || undefined,
          Language: customFilters.language || undefined,
          Price: customFilters.priceRangeId || undefined,
          Page: currentPage,
          PageCount: 12,
        },
      });

      const items = response.data.items || [];
      setSpeakers(items);
      setTotalPages(response.data.metadata?.totalPages || 1);

      const uniqueSpecialities = new Set();
      const uniqueCountries = new Set();

      items.forEach((speaker) => {
        speaker.speakerSpecialies?.forEach((s) =>
          uniqueSpecialities.add(s.specialityId)
        );
        if (speaker.nationality?.id) {
          uniqueCountries.add(speaker.nationality.id);
        }
      });

      setStats({
        total: response.data.metadata?.totalCount || items.length,
        specialities: uniqueSpecialities.size,
        countries: uniqueCountries.size,
      });
    } catch (error) {
      console.error("Error fetching speakers:", error);
      toast.error(error?.detail || error?.title || error?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchInvitation = async (eventId, speakerId) => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/speakers/events/${eventId}/invitations`,
        { params: { speakerId } }
      );
      console.log("Response Data:", response.data);
      setInvitations(response.data.items || []);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.detail || error?.title || error?.message);
    }
  };

  const handleCancelInvitation = async (eventId, invitationId) => {
    try {
      await axiosInstance.put(
        `/api/v1/speakers/events/${eventId}/invitations/${invitationId}/cancel`
      );
      toast.success(t("Invitation cancelled successfully"));
    } catch (error) {
      console.error("API Error:", error);
      toast.error(
        error?.detail ||
          error?.title ||
          error?.message ||
          t("Error cancelling invitation")
      );
    }
  };

  const handleRateInvitation = async (eventId, invitationId) => {
    const rating = prompt("Please enter your rating (1-5):");
    const review = prompt("Please enter your review:");

    if (rating && review) {
      try {
        const response = await axiosInstance.post(
          `/api/v1/speakers/events/${eventId}/invitations/${invitationId}/speaker-rate`,
          {
            speakerRatingByOrganizer: rating,
            speakerReviewByOrganizer: review,
          }
        );
        if (response.status === 200) {
          toast.success(t("Invitation rate successfully!"));
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error(
          error?.detail ||
            error?.title ||
            error?.message ||
            t("Failed to rate invitation.")
        );
      }
    } else {
      toast.error(t("Please enter your rating and criticism."));
    }
  };

  const fetchCities = async (countryId) => {
    if (!countryId) {
      setCities([]);
      return;
    }

    try {
      const citiesResponse = await axiosInstance.get(
        `/api/v1/lookups/cities?countryId=${countryId}`
      );
      setCities(citiesResponse.data.items);
    } catch (error) {
      setCities([]);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "warning";
      case "attended":
        return "success";
      case "cancelled":
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };
  const getVisiblePageNumbers = () => {
    const maxPagesToShow = 5;
    const half = Math.floor(maxPagesToShow / 2);

    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    if (end - start + 1 < maxPagesToShow) {
      if (start === 1) {
        end = Math.min(totalPages, start + maxPagesToShow - 1);
      } else if (end === totalPages) {
        start = Math.max(1, end - maxPagesToShow + 1);
      }
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  useEffect(() => {
    const fetchEventDetails = async () => {
      if (!eventId) return;
      try {
        const response = await axiosInstance.get(
          `/api/v1/speakers/events/${eventId}`
        );
        console.log("Event Data:", response.data);
        setEventData(response.data);
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    fetchEventDetails();
  }, [eventId]);

  useEffect(() => {
    console.log("Fetching invitations...");
    fetchInvitation(eventId, speakerId);
  }, [eventId, speakerId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countriesResponse = await axiosInstance.get(
          "/api/v1/lookups/countries"
        );
        setCountries(countriesResponse.data.items);

        const specialitiesResponse = await axiosInstance.get(
          "/api/v1/lookups/specialities"
        );
        setSpecialities(specialitiesResponse.data.items);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const industriesData = await getIndustries();
        setIndustries(industriesData);
      } catch (error) {
        console.error("Error fetching industries:", error);
      }
    };

    fetchIndustries();
  }, []);

  // جلب المتحدثين
  useEffect(() => {
    fetchSpeakers();
  }, [currentPage]);

  if (!eventData) return <p>{t("Loading...")}</p>;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("invite_speakers")}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {/* Card: البحث والفلاتر */}
            <div className="card mb-4">
              <SpeakerFilters
                filters={filters}
                countries={countries}
                cities={cities}
                industries={industries}
                specialities={specialities}
                priceRanges={priceRanges}
                handleInputChange={handleInputChange}
                resetFilters={resetFilters}
                handleSearch={handleSearch}
                fetchCities={fetchCities}
                onFilterChange={onFilterChange}
              />
            </div>

            {/* بطاقات المتحدثين */}
            {speakers.length > 0 ? (
              <>
                {hasSearched && renderSearchSummary() && (
                  <div className="alert alert-info mt-4" data-aos="fade-in">
                    {renderSearchSummary()}
                  </div>
                )}

                <div className="row" id="speakersSearchResults">
                  {speakers.map((speaker) => {
                    const invitation = invitations.find(
                      (inv) => inv.speakerId === speaker.id
                    );
                    const invitationStatus = invitation?.status;

                    const handleSendInvitation = async () => {
                      if (!eventId) {
                        toast.error(
                          "رقم الحدث غير موجود، لا يمكن إرسال الدعوة"
                        );
                        console.error("Missing eventId");
                        return;
                      }

                      try {
                        const response = await axiosInstance.post(
                          `/api/v1/speakers/events/${eventId}/invitations`,
                          {
                            speakerId: speaker.id,
                            invitationMessage:
                              "نرجو منك المشاركة في هذا الحدث القيّم",
                          }
                        );
                        toast.success(t("Invitation sent successfully"));
                        fetchInvitation(eventId, speaker.id);
                      } catch (error) {
                        console.error("Error sending invitation:", error);
                        toast.error(
                          error?.response?.data?.detail || error?.message
                        );
                      }
                    };

                    return (
                      <div className="col-md-6 col-lg-4 mb-4" key={speaker.id}>
                        <div className="card hover-card h-100 shadow-sm">
                          <div className="card-body">
                            <div className="d-flex align-items-center mb-3">
                              <div className="speaker-avatar me-3">
                                <img
                                  src={
                                    speaker.profileImage ||
                                    "/website/assets/profile-placeholder-9.jpg"
                                  }
                                  alt="صورة المتحدث"
                                  className="rounded-circle"
                                  width="60"
                                  height="60"
                                />
                              </div>
                              <div>
                                <h5 className="card-title mb-1">
                                  {speaker.arabicFullName}
                                </h5>
                                <p className="card-subtitle text-muted mb-0">
                                  {speaker.arabicJobTitle}
                                </p>
                              </div>
                            </div>

                            <div className="mb-3">
                              <div className="d-flex align-items-center mb-2">
                                <i className="fas fa-location-dot text-primary-custom me-2"></i>
                                <span>
                                  {[
                                    speaker.city?.arabicName,
                                    speaker.city?.state?.arabicName,
                                    speaker.city?.state?.country?.arabicName,
                                  ]
                                    .filter(Boolean)
                                    .join("، ") || t("not_available")}
                                </span>
                              </div>

                              <div className="d-flex align-items-center mb-2">
                                <i className="fas fa-tags text-primary-custom me-2"></i>
                                <span>
                                  {speaker.specialities
                                    ?.map((s) => s.arabicName || s.name)
                                    .join("، ") || t("not_available")}
                                </span>
                              </div>

                              <div className="d-flex align-items-center mb-2">
                                <i className="fas fa-language text-primary-custom me-2"></i>
                                <span>
                                  {speaker.languages?.join("، ") ||
                                    t("not_available")}
                                </span>
                              </div>

                              <div className="d-flex align-items-center mb-2">
                                <i className="fas fa-coins text-primary-custom me-2"></i>
                                <span>
                                  {speaker.showPriceInProfile && speaker.price
                                    ? `${speaker.price} ر.س`
                                    : t("not_available")}
                                </span>
                              </div>
                            </div>

                            {invitationStatus ? (
                              <>
                                <p className="mb-1">
                                  {t("invitation_status")}:{" "}
                                  <span
                                    className={`badge bg-${getStatusColor(
                                      invitationStatus
                                    )}`}
                                  >
                                    {invitation.statusName}
                                  </span>
                                </p>
                                {invitationStatus === "pending" && (
                                  <button
                                    className="btn btn-outline-danger w-100"
                                    onClick={() =>
                                      handleCancelInvitation(
                                        eventId,
                                        invitation.id
                                      )
                                    }
                                  >
                                    {t("cancel_invitation")}
                                  </button>
                                )}
                                {invitationStatus === "attended" && (
                                  <button
                                    className="btn btn-outline-success w-100"
                                    onClick={() =>
                                      handleRateInvitation(
                                        eventId,
                                        invitation.id
                                      )
                                    }
                                  >
                                    {t("rate_speaker")}
                                  </button>
                                )}
                              </>
                            ) : (
                              <button
                                className="btn btn-primary w-100"
                                onClick={handleSendInvitation}
                              >
                                {t("send_invitation")}
                              </button>
                            )}

                            <a
                              href={`/speaker-detail/${speaker.id}`}
                              className="btn btn-outline-secondary w-100 mt-2"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {t("view_profile")}
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <p className="text-muted">{t("no_results_found")}</p>
            )}

            {/* Pagination Controls */}
            <nav aria-label="Search pagination" className="mt-3">
              <ul className="pagination justify-content-center">
                {/* السهم الأيمن (السابق) */}
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => {
                      if (currentPage > 1) setCurrentPage(currentPage - 1);
                    }}
                    aria-disabled={currentPage === 1}
                  >
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </li>

                {/* أرقام الصفحات الديناميكية */}
                {getVisiblePageNumbers().map((pageNum, index, array) => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      currentPage === pageNum ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                ))}

                {/* السهم الأيسر (التالي) */}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => {
                      if (currentPage < totalPages)
                        setCurrentPage(currentPage + 1);
                    }}
                    aria-disabled={currentPage === totalPages}
                  >
                    <i className="fas fa-chevron-left"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t("close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InviteModal;
